<div class="contacts">
    <div class="info-item">

        <h2> Политика использования файлов cookie
        </h2>

        <div class="delivery-question">
            <div class="info-header">

                Последнее обновление: 21.02.2025г.
            </div>
            <div class="text">

                Мы используем файлы cookie для улучшения работы сайта. Этот документ объясняет, какие cookies мы
                используем,
                зачем они нужны и как их удалить.

            </div>
        </div>
        <div class="delivery-question">

            <div class="info-header">

                Что такое cookies?
            </div>
            <div class="text">

                Cookies — это небольшие текстовые файлы, которые хранятся на вашем устройстве при посещении веб-сайта.
                Они
                помогают
                сайту запоминать ваши настройки, например, ваш регион.

            </div>
        </div>
        <div class="delivery-question">


            <div class="info-header">

                Какие cookies мы используем?
            </div>
            <div class="text">

                Мы используем только функциональные cookie, которые запоминают Ваш регион для правильного отображения контента.
                Срок хранения cookies - 1 месяц.<br/><br/>

                <strong>Важно:  Эти cookies не передают данные третьим лицам, не содержат личной информации и не используются для
                рекламы
                или
                аналитики.</strong>

            </div>
        </div>
        <div class="delivery-question">

            <div class="info-header">

                Как удалить или отключить cookies?
            </div>
            <div class="text">
                Вы можете удалить или заблокировать cookies в настройках браузера:
                <ul>
                    <li><strong>Google Chrome:</strong> Настройки → Конфиденциальность и безопасность → Cookies и другие данные сайтов</li>
                    <li><strong>Mozilla Firefox:</strong> Настройки → Конфиденциальность и защита → Cookies и данные сайтов</li>
                    <li><strong>Safari:</strong> Настройки → Конфиденциальность → Управление cookies</li>
                    <li><strong>Edge:</strong> Настройки → Файлы cookie и разрешения сайта</li>
                </ul>


                Подробнее о cookies можно узнать на <a href="https://allaboutcookies.org/">allaboutcookies.org</a>.

            </div>
        </div>
    </div>

</div>
